import {Injectable, signal} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Params} from '@angular/router';
import {CommonTableData} from '@lib-ui/common-table/models/common-table-data.class';
import {MessageService} from '@lib-services/message.service';
import {ILocation} from '@lib-typing/location.interface';
import {LocationService} from '@lib-services/location.service';
import {ICommonTableConfig, ICommonTableService} from '@lib-ui/common-table/models/common-table.interface';
import {PartSearchService} from '@lib-services/part-search.service';

@Injectable({
    providedIn: 'root',
})
export class LocationTableService implements ICommonTableService<ILocation> {
    public tableData$: BehaviorSubject<CommonTableData<ILocation>> = new BehaviorSubject<CommonTableData<ILocation>>(new CommonTableData());
    defaultFilterParams = {
        sortBy: 'createdAt:DESC',
    };
    private readonly commonTableData = new CommonTableData();
    loading = signal<boolean>(false);

    constructor(private locationService: LocationService, private messageService: MessageService,private partSearchService: PartSearchService) {}

    updateData(config: ICommonTableConfig): void {
        this.loading.set(true);
        this.locationService
            .getList(this.createSearchParams(config))
            .subscribe({
                next: response => {
                    this.tableData$.next(new CommonTableData(response));
                },
                error: () => this.messageService.errorMessage('Ошибка загрузки списка адресов'),
            })
            .add(() => this.loading.set(false));
    }

    createSearchParams(config: ICommonTableConfig): Params {
        this.commonTableData.data.length = 0;
        const { pageIndex, itemsPerPage } = config.paginatorConfig;
        const { filters } = config;

        let searchParams: Params = {
            ...this.defaultFilterParams,
            limit: itemsPerPage.toString(),
        };

        if (pageIndex) {
            searchParams = {
                ...searchParams,
                page: pageIndex.toString(),
            };
        }

        if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
                if (value) {
                    let filterValue;
                    let params: string[];

                    switch (key) {
                    case 'address':
                        params = String(value).split(' ').map((el: string) => el.trim());
                        filterValue = [`$ilike:${params[0]}`].concat(this.partSearchService.createMultiStringParams(params.slice(1)));
                        break;
                    default:
                        filterValue = `${value}`;
                    }
                    searchParams = {
                        ...searchParams,
                        [`filter.${key}`]: filterValue,
                    };
                }
            });
        }

        return searchParams;
    }

}
